export const TALENT_POOL_LIST_SUGGESTION_PAGE_SIZE = 3;
export const TALENT_POOL_LIST_PAGE_SIZE = 20;
export const TALENT_POOL_USERS_SEARCH_PAGE_SIZE = 10;
export const TALENT_POOL_FOLDERS_PAGE_SIZE = 20;
export const TALENT_POOL_CANDIDATES_SEARCH_PAGE_SIZE = 20;
export const TALENT_POOL_FOLDERS_HIERARCHY_PAGE_SIZE = 30;
export const TALENT_POOL_CANDIDATES_TABLE_COLUMNS_LIMIT = 20;

export const BULK_ACTION_TYPES = {
  MOVE: 'MOVE',
  COPY: 'COPY',
  ADD: 'ADD',
  ADD_OR_REMOVE: 'ADD_OR_REMOVE',
  ADD_CANDIDATES_TO_FOLDERS_FROM_JOB: 'ADD_CANDIDATES_TO_FOLDERS_FROM_JOB',
} as const;

export const BULK_ACTION_TYPES_OPTIONS = {
  ADD_TO_JOB: 'ADD_TO_JOB',
  MOVE_TO_FOLDER: 'MOVE_TO_FOLDER',
  COPY_TO_FOLDER: 'COPY_TO_FOLDER',
} as const;

export const FOLDER_TYPES = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;

export const BULK_ACTION_LIMIT = {
  MESSAGING: 100,
  BULK_ACTION: 1500,
} as const;
